<template>
  <div>
    <h3 class="om-page-heading">
      {{ isNew ? $tr('Dodawanie nowego sklepu', 'ShopSettings') : $tr('Edytuj dane sklepu', 'ShopSettings') }}
    </h3>
    <div class="om-form" data-vv-scope="shop-form">
      <div class="om-form__group">
        <label for="in-name">{{ $tr('Nazwa sklepu:', 'ShopSettings') }}</label>
        <div class="om-form__input-wrap">
          <input
            :title="$tr('nazwa sklepu', 'ShopSettings')"
            id="in-name"
            type="text"
            v-model="shop.name"
            name="name"
            v-validate="{ rules: { required: true, regex: /^[\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,\-]*$/} }">
        </div>
      </div>
      <transition name="slide-down">
        <div v-if="errors.has('name')" class="om-error om-form__group">{{ errors.first('name') }}</div>
      </transition>
      <div class="om-form__group flex">
        <label for="in-address-street">{{ $tr('Adres sklepu:', 'ShopSettings') }}</label>
        <div class="om-form__input-wrap om-form__input-wrap--street fg-1">
          <input
            :title="$tr('adres sklepu', 'ShopSettings')"
            id="in-address-street"
            type="text"
            v-model="shop.address.street"
            name="address_street"
            v-validate="{ rules: { required: true, regex: /^[\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,\-]*$/} }">
        </div>
        <div class="om-form__input-wrap om-form__input-wrap--house">
          <input
            :title="$tr('nr budynku', 'ShopSettings')"
            id="in-address-house"
            type="text"
            v-model="shop.address.house"
            name="address_house"
            v-validate="{ rules: { regex: /^[0-9A-z]+$/} }">
        </div>
        <div class="om-slash"></div>
        <div class="om-form__input-wrap om-form__input-wrap--flat">
          <input
            :title="$tr('nr lokalu', 'ShopSettings')"
            id="in-address-flat"
            type="text"
            v-model="shop.address.flat"
            name="address_flat"
            v-validate="{ rules: { regex: /^[0-9A-z]+$/} }">
        </div>
      </div>
      <transition name="slide-down">
        <div v-if="errors.has('address_street')" class="om-form__group om-error">{{ errors.first('address_street') }}</div>
        <div v-else-if="errors.has('address_house')" class="om-form__group om-error">{{ errors.first('address_house') }}</div>
        <div v-else-if="errors.has('address_flat')" class="om-form__group om-error">{{ errors.first('address_flat') }}</div>
      </transition>
      <div class="flex">
        <div class="om-form__group">
          <label for="in-address-postcode">{{ $tr('Kod pocztowy:', 'ShopSettings') }}</label>
          <div class="om-form__input-wrap om-form__input-wrap--postcode">
            <input
              :title="$tr('kod pocztowy', 'ShopSettings')"
              id="in-address-postcode"
              type="text"
              v-model="shop.address.postcode"
              name="address_postcode"
              v-validate="{ rules: { required: true, regex: /^([0-9]{2}-[0-9]{3})$/} }">
          </div>
        </div>
        <div class="om-form__group om-form__group--city">
          <label for="in-address-city">{{ $tr('Miasto:', 'ShopSettings') }}</label>
          <div class="om-form__input-wrap">
            <input
              :title="$tr('miasto', 'ShopSettings')"
              id="in-address-city"
              type="text"
              v-model="shop.address.city"
              name="address_city"
              v-validate="{ rules: { required: true, regex: /^[\w żźćńółęąśŻŹĆĄŚĘŁÓŃ.,]*$/} }">
          </div>
        </div>
      </div>
      <transition name="slide-down">
        <div v-if="errors.has('address_postcode')" class="om-form__group om-error">{{ errors.first('address_postcode') }}</div>
        <div v-else-if="errors.has('address_city')" class="om-form__group om-error">{{ errors.first('address_city') }}</div>
      </transition>
      <div class="om-form__group">
        <label for="in-email">{{ $tr('Adres e-mail:', 'ShopSettings') }}</label>
        <div class="om-form__input-wrap">
          <input
            :title="$tr('adres e-mail', 'ShopSettings')"
            id="in-email"
            type="text"
            v-model="shop.email"
            name="email"
            v-validate="'required|email'">
        </div>
      </div>
      <transition name="slide-down">
        <div v-if="errors.has('email')" class="om-error om-form__group">{{ errors.first('email') }}</div>
      </transition>
      <div class="om-form__group">
        <label for="in-password">{{ $tr('Hasło:', 'ShopSettings') }}</label>
        <div class="om-form__input-wrap">
          <input
            :title="$tr('hasło', 'ShopSettings')"
            id="in-password"
            type="password"
            v-model="password"
            name="password">
        </div>
      </div>
      <transition name="slide-down">
        <div v-if="errors.has('password')" class="om-error om-form__group">{{ errors.first('password') }}</div>
      </transition>
      <div class="om-form__group">
        <label for="in-confirmation">{{ $tr('Powtórz hasło:', 'ShopSettings') }}</label>
        <div class="om-form__input-wrap">
          <input
            :title="$tr('powtórz hasło', 'ShopSettings')"
            id="in-confirmation"
            type="password"
            v-model="confirmation"
            name="confirmation"
            @blur="confirmationBlurred = true">
        </div>
      </div>
      <transition name="slide-down">
        <div v-if="errors.has('confirmation')" class="om-error om-form__group">{{ errors.first('confirmation') }}</div>
        <div v-else-if="password !== confirmation" class="om-error om-form__group">{{ $tr('Hasła do siebie nie pasują', 'ShopSettings') }}</div>
      </transition>
      <div class="om-form__group">
        <button class="om-btn om-form__submit" @click.prevent="pushShop">
          {{ $tr('Zapisz zmiany', 'ShopSettings') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'shop-settings',
    data () {
      return {
        notFound: false,
        isNew: false,
        shop: {
          address: {
            street: '',
            address: '',
            address1: '',
            address2: '',
            postcode: ''
          },
          name: '',
          code: 0,
          email: '',
          can_return: false,
          can_collect: false
        },
        password: '',
        confirmation: '',
        confirmationBlurred: false
      }
    },
    mounted () {
      if (typeof this.$route.params.code !== 'undefined') {
        if (this.$route.params.code === 'new') {
          this.isNew = true
        } else {
          this.$http.get(this.$router.options.getApiRoute('shop-settings', {code: this.$route.params.code})).then((resp) => {
            if (typeof resp.body[0] !== 'undefined') {
              console.log(resp.body[0])
              this.shop = resp.body[0]
              this.notFound = false
            } else {
              this.notFound = true
            }
          },
          (resp) => {
            console.log(resp.body)
            this.notFound = true
          })
        }
      }
    },
    methods: {
      pushShop () {
        this.$validator.validateAll({
          name: this.shop.name,
          address_street: this.shop.address.street,
          address_house: this.shop.address.house,
          address_flat: this.shop.address.flat,
          address_postcode: this.shop.address.postcode,
          email: this.shop.email,
          password: this.password,
          confirmation: this.confirmation
        })
        .then(result => {
          if (result) {
            this.$http.post(this.$router.options.getApiRoute('shop-settings', {code: this.shop.code}), {
              shop: this.shop,
              password: this.password,
              confirmation: this.confirmation
            }).then((resp) => {
              console.log(resp.body)
              if (resp.ok) {
                this.$router.push({name: 'ShopList'})
              }
            },
            (resp) => {
              console.log(resp)
              if (typeof resp.body.errors !== 'undefined' && Object.getOwnPropertyNames(resp.body.errors).length > 0) {
                for (let e in resp.body.errors) {
                  this.$alertify.notify(resp.body.errors[e], 'error', 3)
                }
              }
            })
          } else {
            this.$alertify.notify(this.$tr('Popraw dane', 'ShopSettings'), 'error', 3)
          }
        }).catch(() => {
          // something went wrong (non-validation related).
          console.log('error to catch')
        })
      }
    },
    computed: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../../assets/scss/settings";
  @import "../../assets/scss/utilities";
  
  .om-error{
    color: $omni-color-error;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    &.om-form__group{
      margin-top: -11px;
      margin-bottom: 6px;
    }
  }
  
</style>



// WEBPACK FOOTER //
// ShopSettings.vue?5ecf322e